import { forwardRef, useImperativeHandle, type Ref } from 'react';
import { useFormState } from 'react-hook-form';

export type ServiceFormDirtyObserverRef = {
    isDirty: boolean;
};

const InnerServiceFormDirtyObserver = (
    _: { children?: never },
    ref: Ref<ServiceFormDirtyObserverRef>,
) => {
    const { isDirty } = useFormState();

    useImperativeHandle(ref, () => ({ isDirty }), [isDirty]);

    return null;
};

export const ServiceFormDirtyObserver = forwardRef(
    InnerServiceFormDirtyObserver,
);

ServiceFormDirtyObserver.displayName = 'ServiceFormDirtyObserver';
